import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { DEFAULT_PAGINATION } from "@constants/index";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

// import { isValidDate, parseDate } from "@utils/dateValidation";
import { Pagination } from "@customTypes/index";
import { Patient } from "@customTypes/patient";

import { patientQKeys } from "./queryKeys";

//! TEMPORARY - WILL DELETE THIS LATER
const select = (res: any) => {
  //   console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };

  if (res.data.data.length) {
    const newData: Partial<Patient>[] = [];

    for (const i in res.data.data) {
      const { patient_id, first_name, surname, dob, created_at } =
        res.data.data[i];

      newData.push({
        patientId: patient_id,
        firstName: first_name,
        surname,
        dob,
        createdAt: new Date(created_at),
      });
    }
    // console.log(newData);
    return { newData, pagination };
  }
  return null;
};

interface QueryProps {
  isEnabled?: boolean;
  pagination?: Partial<Pagination>;
  search?: string;
  fields?: string[];
}

export const useGetPatientsBySearchOnly = ({
  isEnabled = true,
  pagination,
  search,
  fields,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: patientQKeys.allWithFilters({
      pagination,
      ...(search && { search }),
      fields,
    }),
    queryFn: () => {
      //* Temporary ------------------------------------
      if (!search) {
        return Promise.resolve({
          data: {
            data: {
              newData: [],
            },
            pagination: { ...DEFAULT_PAGINATION },
          },
        });
      }
      //* End Temporary ------------------------------------

      return api.get("patient/all", {
        params: {
          ...(search && { search }),
          ...(pagination && {
            page: pagination.page,
            page_size: pagination.pageSize,
          }),
          ...(fields?.length && { fields: fields.join(",") }),
        },
      });
    },
    select,
    enabled: isEnabled,
    // keepPreviousData: true,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Patients]", res);
      handleErrors(res, "query");
    },
  });
};
